import { Component } from '@angular/core';

@Component({
  templateUrl: '500.component.html',
  selector: 'twaice-fe-500',
  standalone: false,
})
export class P500Component {}
